import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../constants";
import { ShareContext } from "../context/ShareContext";
import BackLoader from "../components/backloader";
import JisButton from "../components/controls/jisButton";
import CaseSearch from "../components/core/case_search";
import "../styles/casedetails.css";

function UncompletedUploads() {
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);

  const [docs, setDocs] = useState([]);
  const [cases, setCases] = useState([]);
  const [refs, setRefs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [casetype, setCaseType] = useState("litigation");

  const navigate = useNavigate();
  useEffect(() => {
    onLoad();
  }, []);

  const onLoad = async () => {
    //for account registration
    setCaseType("litigation");
    var url = `${Constants.apiUrl}/filing/uncompletedUpload`;

    try {
      setLoading(true);
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      if (data.code == 0) {
      }
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        setDocs(data.docs);
        /*   setCases(data.cases);
                setRefs(data.refs); */
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        alert(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onView = (item) => {
    navigate(`/document-upload/${item.caseFeeId}`);
  };

  return (
    <div>
      <div>
        <div>
          <div className="table-header">
            <p>Pending Uploads</p>
          </div>
          <div className="table-wrapper ">
            <table className="case-details-table full-border">
              <thead>
                <tr>
                  {/* <th className="col-id">ID</th> */}

                  <th className="col-title">Suit Number</th>
                  <th className="col-title"> Title</th>
                  <th>Document Count</th>
                  <th>Status</th>
                  <th className="col-action">Actions</th>
                </tr>
              </thead>
              <tbody>
                {docs.map((item, id) => {
                  return (
                    <tr key={id}>
                      {/*  <td>{item.id}</td> */}
                      <td>
                        {item?.case?.caseNumber ||
                          item?.case.referenceNumber ||
                          "N/A"}
                      </td>
                      <td>{item.case.caseTitle || "N/A"}</td>
                      <td>{item.linecount || "N/A"}</td>
                      <td>
                        {item.isCompleted
                          ? "Process Completed"
                          : "Pending Upload"}
                      </td>
                      <td>
                        {" "}
                        {!item.isCompleted ? (
                          <JisButton
                            variant="plain"
                            onClick={() => onView(item)}
                          >
                            Upload
                          </JisButton>
                        ) : (
                          "N/A"
                        )}{" "}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <BackLoader open={loading} />
    </div>
  );
}

export default UncompletedUploads;
